import { useState } from "react";
import LocationsTab from "./org-management/LocationsTab";
import DepartmentsTab from "./org-management/DepartmentsTab";
import EmployeesTab from "./org-management/EmployeesTab";
import "../styles/org-management.css";

const TABS = [
  { id: "locations", label: "Locations", icon: "📍" },
  { id: "departments", label: "Departments", icon: "🏷️" },
  { id: "employees", label: "Employees", icon: "👤" },
] as const;

type TabId = (typeof TABS)[number]["id"];

export default function OrgManagement() {
  const [activeTab, setActiveTab] = useState<TabId>("locations");

  return (
    <div>
      <h1>Organization Management</h1>
      <p className="page-subtitle">
        Manage locations, departments, and employees across your organization
      </p>

      <div className="org-mgmt-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`org-mgmt-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
            type="button"
          >
            <span>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "locations" && <LocationsTab />}
      {activeTab === "departments" && <DepartmentsTab />}
      {activeTab === "employees" && <EmployeesTab />}
    </div>
  );
}
